import { mapEditorialContent } from '@cobalt/utilities';
import LivePollingInstance from '@live/pollingHandler';
import { language } from '@utilities/browser';

export default class LiveArticlePlugin {
  dom: HTMLElement;
  options: any;

  constructor(dom: HTMLElement, o: any) {
    this.dom = dom;

    this.options = {
      ...o,
    };
  }

  get articleUrl() {
    return `${window.cobaltApiUrl}pages?url=${
      this.options.newsTag
    }/${language?.toUpperCase()}&aggregator=lightpagejson`;
  }

  get articleTitle() {
    return this.dom?.querySelector<HTMLElement>('.js-article-title');
  }

  get articleSummary() {
    return this.dom?.querySelector<HTMLElement>('.js-article-summary');
  }

  get articlePicture() {
    return this.dom?.querySelector<HTMLElement>('.js-article-picture');
  }

  init() {
    LivePollingInstance.on(
      this.articleUrl,
      [{ key: 'x-api-key', value: window.cobaltApiKey }],
      this.options.pollingInterval,
      this.onUpdate,
      this,
    );
    this.storytellerWithHeroCard();
  }

  detach() {
    LivePollingInstance.off(this.articleUrl, this.onUpdate, this);
  }

  onUpdate(response) {
    const article = mapEditorialContent(response?.model?.data, response?.model?.nodes) ?? {};
    if (!article.id) return;

    this.articleTitle.innerText = article.title;
    this.articleSummary.innerText = article.description;

    const image = article.mainMedia?.image;
    this.setImage(image);
  }

  setImage(image) {
    if (!image) return;
    this.articlePicture &&
      this.articlePicture.querySelectorAll<HTMLElement>('source,img').forEach((el) => {
        const format = el.dataset.format;
        const ratio = format.charAt(0);
        const src = this.getCobaltImageUrls(image, ratio);
        el.dataset.srcset = src;
      });
  }

  getCobaltImageUrls(image, ratio: string) {
    let f;
    switch (ratio.toLowerCase()) {
      case 'f':
        f = image.free;
        break;
      case 'w':
        f = image.wide;
        break;
      case 's':
        f = image.square;
        break;
      case 'p':
        f = image.portrait;
        break;
      case 'u':
        f = image.ultraWide;
        break;
      default:
        f = image.custom ?? '';
        break;
    }

    return f ? (f[`${ratio}1`] ?? f[ratio] ?? Object.values(f)?.[0]) : '';
  }

  storytellerWithHeroCard() {
    const storytellerWrapper = document.querySelector<HTMLElement>('.storyteller-wrapper');
    if (!storytellerWrapper) return;
    this.dom.style.marginTop = 'unset';
  }
}
